import ContentErrors from "@/react/story/components/ContentErrors";

type Props = {
    active: boolean;
    label: string;
    onClick: () => void;
    errors?: string[];
}

export default function TabButton(props: Props) {
    return (
        <li className="nav-item" role="presentation">
            <button
                type="button"
                className={`d-flex gap-1 nav-link ${props.active ? "active" : ""}`}
                role="tab"
                onClick={() => props.onClick()}
            >
                {props.label}
                {props.errors ? (
                    <ContentErrors errors={props.errors} />
                ) : null}
            </button>
        </li>
    );
}
